import React from 'react';
import { apiIsLoggedIn } from '../api/api';
import '../styles/familytree.css';
import TopBarMain from '../components/topbars/TopBarMain';

class FamilyTreePage extends React.Component {
    constructor(props) {
        super(props);
    }
    
    componentDidMount() {
        apiIsLoggedIn().then(isLoggedIn => {
            if (!isLoggedIn) {
                window.location.href = '/';
            }
        });
    }

    render() {
        return (
            <div>
                <TopBarMain />
                <div className='family-tree-page'>
                    <h2>Family Tree</h2>
                    <p>Coming soon! Please email <a href="mailto:ramsey.opp@gmail.com">ramsey.opp@gmail.com</a> if you have any information to help.</p>
                </div>
            </div>
        );
    }
}

export default FamilyTreePage;
